import React from "react";
import classNames from "classnames";
import { WidgetLocation } from "@data-types/live-widget/WidgetLocation";
import { DeviceDetector } from "@utils";

export function MessageContainer(props: {
	message: string | null | undefined;
	isError: boolean;
	location: WidgetLocation;
	customClass?: string;
}) {
	const { message, isError, location, customClass } = props;

	const messageClasses = classNames("message", customClass, {
		"message--base":
			location != WidgetLocation.SIDE && !DeviceDetector.isMobileTheme,
		"message--sml":
			location == WidgetLocation.SIDE || DeviceDetector.isMobileTheme,
		"message--note": !isError,
		"message--danger": isError,
	});

	const iconClasses = classNames("message__icon u-icon", {
		"u-icon--lrg":
			location != WidgetLocation.SIDE && !DeviceDetector.isMobileTheme,
		"u-icon--big":
			location == WidgetLocation.SIDE || DeviceDetector.isMobileTheme,
		"u-icon--info-circle u-color--sent--note": !isError,
		"u-icon--remove-circle u-color--sent--danger": isError,
	});

	return (
		<div className={messageClasses}>
			<i className={iconClasses} />
			<div className="message__content">{message}</div>
		</div>
	);
}
